import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { GalleryIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery',
)({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle title="Gallery Management" id="storeManagement.galleryManagement.crumb" icon={GalleryIcon} />,
      title: <Translation id="storeManagement.galleryManagement.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
